import { useEffect, useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import AudioRecorder from "./AudioRecorder";
import TextParticipation from "./TextParticipation";
import Compteur from "./Compteur";

function Temoinage({
    interaction,
    participation,
    audioURL,
    setAudioURL,
    audioBlob,
    setAudioBlob,
    sendRecordParticipation,
    maxRecordingTime,
    setMessageErreur,
    sendingParticipationState,
    changerEtapeCollecteParticipationTexte,
    changerEtapeCollecteParticipationVocale,
    passerPageTemoignage,
    retourAccueil,
    EcritUniquement = false,
    handleStartRecording,
    counter,
    afficherCompteur,
    setAfficherCompteur,
    handleAfficherCompteur,
    showPassable = true,
    showRetour = true,
    setAfficherEtapeCollecteParticipationImage,
    isFranceInter = false,
}) {

    // Si l'URL est renseignée un témoinage vocale a été enregistré a l'issu de
    // l'enregistrement React effectue un rendu de cette page il est donc
    // nécessaire de réinitialiser avec la bonne valeur l'affichage du champ
    const [afficherTemoinageVocale, setAfficherTemoinageVocale] = useState(audioURL || false);
    const [afficherTemoinageEcrit, setAfficherTemoinageEcrit] = useState(false);



    const changeAfficherTemoinageVocale = () => {
        setAfficherTemoinageVocale(!afficherTemoinageVocale);
        setAfficherTemoinageEcrit(false);
        setAfficherEtapeCollecteParticipationImage(false);
    }
    const changeAfficherTemoinageEcrit = () => {
        setAfficherTemoinageEcrit(!afficherTemoinageEcrit);
        setAfficherTemoinageVocale(false);
        setAfficherEtapeCollecteParticipationImage(false);
    }

    useEffect(() => {
        if (EcritUniquement) {
            changeAfficherTemoinageEcrit();
        }
        // eslint-disable-next-line 
    }, [EcritUniquement])


    //Configuration du texte des boutons
    const textTemoignageVocal = 'Envoyer un message vocal';
    const textTemoignageEcrit = 'Envoyer un message écrit';

    return (
        <>
            <div className="custom-temoignage">
                <p className="custom-text">{interaction.testimonial}</p>
                {afficherTemoinageVocale &&
                    <>

                        <Row className="text-center">
                            <Col>

                                <AudioRecorder
                                    audioURL={audioURL}
                                    setAudioURL={setAudioURL}
                                    audioBlob={audioBlob}
                                    setAudioBlob={setAudioBlob}
                                    sendRecordParticipation={sendRecordParticipation}
                                    maxRecordingTime={maxRecordingTime}
                                    setMessageErreur={setMessageErreur}
                                    sendingParticipationState={sendingParticipationState}
                                    changerEtapeCollecteParticipationVocale={changerEtapeCollecteParticipationVocale}
                                    participation={participation}
                                    onStartRecording={handleStartRecording}
                                    setAfficherCompteur={setAfficherCompteur}
                                    onRestartRecording={handleAfficherCompteur}
                                    setAfficherEtapeCollecteParticipationImage={setAfficherEtapeCollecteParticipationImage}
                                />
                            </Col>
                        </Row>
                        {afficherCompteur && audioURL === '' &&
                            <Compteur className="text-center" counter={counter} />
                        }
                    </>
                }
                {afficherTemoinageEcrit &&
                    <>
                        <Row className="text-center">
                            <Col>
                                <TextParticipation
                                    participation={participation}
                                    sendingParticipationState={sendingParticipationState}
                                    changerEtapeCollecteParticipationTexte={changerEtapeCollecteParticipationTexte}
                                />
                            </Col>
                        </Row>
                    </>
                }

                {!afficherTemoinageVocale && !afficherTemoinageEcrit && !EcritUniquement &&
                    <Row className="text-center">
                        <Col>
                            <Button onClick={changeAfficherTemoinageVocale} className="btn-ajouter-temoignage-vocal">{textTemoignageVocal}</Button>
                        </Col>
                    </Row>
                }
                {!afficherTemoinageEcrit && !afficherTemoinageVocale &&
                    <Row className="text-center">
                        <Col>
                            <Button onClick={changeAfficherTemoinageEcrit} className="btn-ajouter-temoignage-ecrit">{textTemoignageEcrit}</Button>
                        </Col>
                    </Row>
                }
                {!afficherTemoinageEcrit && !afficherTemoinageVocale && showPassable &&
                    <Row className="text-center text-ou-temoignage">
                        <Col>
                            <p>Ou</p>
                        </Col>
                    </Row>
                }
            </div>
            {!afficherTemoinageEcrit && !afficherTemoinageVocale && showPassable &&
                <Row className="text-center btn-bold">
                    <Col>
                        <Button onClick={passerPageTemoignage}>Passer</Button>
                    </Col>
                </Row>
            }
            {showRetour &&
                <Row className="text-center">
                    <Col>
                        <Button onClick={retourAccueil} className="custom-btn-retour">Retour</Button>
                    </Col>
                </Row>
            }
        </>);
}

export default Temoinage;